module.exports = __webpack_public_path__ + "static/media/money.ecf23a75.png";